import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classes from './SiteNavAMobileLevelD.module.scss';

const SiteNavAMobileLevelD = (props) => {
  const {
    items = [],
    href,
    subHeading,
  } = props;

  if (!items.length) {
    return null;
  }

  return (
    <div className={classes.container}>
      {subHeading &&
        <div className={classes.levelCLinkWrapper}>
          <a aria-label={subHeading} href={href}>
            <span
              dangerouslySetInnerHTML={{ __html: subHeading }}
            />
            <FontIcon className={classes.icon} icon='far fa-chevron-right' />
          </a>
        </div>}
      <div className={classes.listContainer}>
        <div className={classes.listWrapper}>
          <ul className={classes.list}>
            {items.map((item, index) => (
              <li key={index}>
                <a
                  aria-label={item.heading}
                  href={item.href}
                  target={item.target}
                  dangerouslySetInnerHTML={{ __html: item.heading }}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

SiteNavAMobileLevelD.propTypes = {
  items: PropTypes.array,
  href: PropTypes.string,
  subHeading: PropTypes.string,
};

export default SiteNavAMobileLevelD;
